import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Logo from '../assets/w-logo 1@2x.png'; // Import your logo here
import FooterLogo from '../assets/FooterLogo.png'; // Import your logo here
import { COMEFUNZIONA, CONTATTI } from '../Routes/constURL';
import { Link } from 'react-router-dom';
// import FooterLogo from './FooterLogo';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  footer: {
    backgroundColor: '#1C1D53', // Dark blue background
    color: '#CECECE;',
    padding: '30px 30px',
  },
  logo: {
    width: '100px', // Adjust size as needed
  },
  sectionTitle: {
    marginBottom: '10px',
    fontSize: '20px',
    fontWeight: 400,
    "&.MuiTypography-root": {
      lineHeight: 2,
      fontSize: '20px',

    }
  },
  link: {
    color: '#CECECE;',
    fontSize: '20px',
    textDecoration: 'none',
    marginBottom: '8px',
    display: 'block',
    fontWeight: 400,
  },
  address: {
    fontWeight: 300,
    "&.MuiTypography-root": {
      marginBottom: "5px",
      color: "#A8A8A8",
      fontSize:"14px"
    }
  },
  grid: {
    "&.MuiGrid-root": {
      marginTop: "44px"
    }
  },
  FooterLogo:{
    width:'230px'
  }
});

const Footer = () => {
  const classes = useStyles();
  const { t } = useTranslation(); // Use translation hook

  return (
    <Box className={classes.footer}>
      <Grid container spacing={4}>
        {/* Left Section - Logo */}
        <Grid item xs={12} sm={12} display={"flex"} sx={{ justifyContent: { xs: "center", sm: "flex-start",pl:{xs:0,md:1} } }}>
          {/* <img src={Logo} alt="Logo" className={classes.logo} /> */}
          <img src={FooterLogo} alt="Logo" className={classes.FooterLogo} />
          {/* <FooterLogo /> */}
        </Grid>

        {/* Middle Section - Quick Links */}
        <Grid container xs={12} sm={12} sx={{ paddingLeft: {xs:"5%",md:"20%"}, textAlign: { xs: "center", md: "start" }, mt: { xs: 2, md: 0 } }}>
          <Grid item xs={12} sm={4}>
            <Typography className={classes.sectionTitle}>
              {t('footer.Links')}
            </Typography>
            <Link to={COMEFUNZIONA} className={classes.link}>
              {t('footer.how_it_works')}
            </Link>
            <Link to={CONTATTI} className={classes.link}>
              {t('footer.contacts')}
            </Link>
            <Link to={"https://clink.team/"} target='_blank' className={classes.link}>
              {t('footer.clink')}
            </Link>
          </Grid>

          {/* Right Section - Contact Information */}
          <Grid item xs={12} sm={4} mt={2} rowGap={2} className={classes.grid} >
            <Typography className={classes.address}>
              Clink
            </Typography>
            <Typography className={classes.address}>
              Clink@Clink.team
            </Typography>
            <Typography className={classes.address}>
              Largo Parolini, 6
            </Typography>
            <Typography className={classes.address}>
              36061 - Bassano Del Grappa, VI
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Footer;
